import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./ContactUs.css";
import "../Home/Home.css";
import Input from "../../components/Elements/Input/Input";
import ButtonComponent from "../../components/Elements/Button/Button";
import { EMAIL_REGEX, PHONE_REGEX, SHEET_API_URL } from "../../utils/Regex";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const contactforminputs=[
  //   { label:  "Full Name *", placeholder: "Full Name", name: "fullName" },
  //   { label:" Email ", placeholder:" Email", name: "email" },
  //   { label:" Phone ", placeholder:" Phone", name: "phone" },
  //   { label: "message *", placeholder:"message ", name: "message" },
  // ]

  const contactforminputs = [
    { label: "Full Name *", placeholder: "Full Name", name: "fullName" },
    { label: " Email *", placeholder: " Email", name: "email" },
    { label: " Phone *", placeholder: " Phone", name: "phone" },
    { label: "message *", placeholder: "message ", name: "message" },
  ];
  const validate = (values: any) => {
    const errors: any = {};

    if (!values.fullName) {
      errors.fullName = "Full Name is required";
    }

    if (!values.email) {
      errors.email = "Email is required";
    } else if (!EMAIL_REGEX.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.phone) {
      errors.phone = "Phone number is required";
    } else if (!PHONE_REGEX.test(values.phone)) {
      errors.phone = "Contact number must be 10 digits";
    }

    if (!values.message) {
      errors.message = "Company is required";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phone: "",
      message: "",
    },
    validate,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true); // Start loader

      try {
        const response = await axios.post(
          `${SHEET_API_URL}?action=doPostContact`, // for hire us use action=doPostHireUS and drop resume action=doPostDrop
          JSON.stringify({
            fullName: values.fullName,
            emailId: values.email,
            phoneNumber: values.phone,
            message: values.message,
          })
        );

        console.log("Response from API:", response.data);
        if (response.data.success) {
          // alert("Form submitted successfully!");
          toast.success("Form submitted successfully!");
          resetForm(); // 👈 Reset the form here
        } else {
          // alert("Something went wrong. Please try again.");
          toast.error("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        // alert("Error submitting form. Please check console.");
        toast.error("Error submitting form. Please check console.");
      } finally {
        setIsSubmitting(false); // Stop loader
      }
    },
  });

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Box className="contacts-main">
        <Typography className="contacts-heading">
          {t("contacts.contactUs")}
        </Typography>
      </Box>
      <Box className="contactus-main">
        {/* Form on the left */}
        <Box className="contactus-form-container">
          <Typography
            className="contactus-headding"
            width={"60%"}
            textTransform={"uppercase"}
          >
            {t("contacts.joinUs")}
          </Typography>
          <form className="formStyle" onSubmit={formik.handleSubmit}>
            <Box display={"flex"} flexWrap={"wrap"} gap={"20px"} mt={3}>
              {contactforminputs.map((input, index) => (
                <Box key={index} width={"100%"}>
                  <Input
                    className="contactLogin"
                    label={input.label}
                    placeholder={input.placeholder}
                    name={input.name}
                    id={input.name}
                    value={(formik as any)?.values[input.name]}
                    onChange={formik.handleChange}
                    error={
                      (formik as any).errors[input.name] &&
                      (formik as any).touched[input.name]
                        ? (formik as any).errors[input.name]
                        : ""
                    }
                    onBlur={formik.handleBlur}
                    touched={(formik as any).touched[input.name]}
                  />
                </Box>
              ))}
              <ButtonComponent
                type={"submit"}
                className={"HireButton"}
                style={{
                  background: "#741374",
                  color: "white",
                  width: "209px !important",
                  marginTop: "25px",
                }}
                disable={isSubmitting}
              >
                {/* {t('contacts.submit')} */}
                {/* Send Message */}
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Send Message"
                )}
              </ButtonComponent>
            </Box>
          </form>
        </Box>

        {/* Box on the right */}
        <Box className="box-icon-caotactus">
          {/* Add content to this box as needed */}
          <Box padding={"50px"}>
            <Typography className="contact-box-heading" mb={1}>
              {t("contacts.address")} :-
            </Typography>
            <Typography className="contact-box-paragraph" mb={1}>
              {/* {t("contacts.addressText")} */}
              <p>
                Road 5124
                <br />
                Block 351
                <br />
                Building 1195
                <br />
                Floor 5 | Flat 51
                <br />
                Al Suwayfiyah
                <br />
                Kingdom of Bahrain
              </p>
              {/* <p>
                Flat 51, 5th Floor
                <br />
                HSDC Building 1195
                <br />
                Road/Street Number 5124, Block 351
                <br />
                Manama / Al Suwayfiyah
                <br />
                Bahrain
              </p> */}
            </Typography>
            <Typography className="contact-box-heading" mb={1.5} mt={5}>
              {t("contacts.contact")} :-
            </Typography>
            <Typography className="contact-box-paragraph" mb={1.5}>
              {" "}
              {/* <span dir="ltr">{t("contacts.phoneNumber")} :</span> +973 77022200 */}
              {/* +973 77022200 */}
              +973 39 905077
              <br />
              +973 33 635233
              <br />
              {/* +97333635866 */}
              <br />
            </Typography>

            <Typography className="contact-box-heading" mb={1.5}>
              {t("footer.Email")} :- <br />
              <Link
                to="mailto:info@almaalybh.com"
                style={{ textDecoration: "none" }}
                className="footer-menues"
              >
                {/* info@almaalybh.com{" "} */}
                info@almaalybh.com
                <br />
                brm@almaalybh.com
              </Link>
            </Typography>
            {/* <Typography className="contact-box-heading" mb={1.5} mt={5}>
              {t("contacts.openTime")}
            </Typography>
            <Typography className="contact-box-paragraph" mb={2}>
              {t("contacts.openTimeDetails")}
            </Typography>
            <Typography className="contact-box-heading" mb={2} mt={5}>
              {t("contacts.stayConnected")}
            </Typography> */}
          </Box>
        </Box>
      </Box>

      <Box mt={-1}>
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28631.390760757087!2d50.5230928!3d26.2316639!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49af07ea4895df%3A0xa5ed4e70bf91b67b!2sAl%20Maaly%20Recruitment!5e0!3m2!1sen!2sin!4v1745230498571!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe> */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3579.0816015061123!2d50.553070075416024!3d26.226537977062875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDEzJzM1LjUiTiA1MMKwMzMnMjAuMyJF!5e0!3m2!1sen!2sin!4v1750943343271!5m2!1sen!2sin" width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          ></iframe>
        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28631.390760757087!2d50.5230928!3d26.2316639!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49af07ea4895df%3A0xa5ed4e70bf91b67b!2sAl%20Maaly%20Recruitment!5e0!3m2!1sen!2sin!4v1745230498571!5m2!1sen!2sin"           allowFullScreen
  loading="lazy" ></iframe> */}
      </Box>
    </>
  );
};

export default ContactUs;
